import { render, staticRenderFns } from "./AppDetailHeader.vue?vue&type=template&id=414636d8&scoped=true&"
var script = {}
import style0 from "./AppDetailHeader.vue?vue&type=style&index=0&id=414636d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414636d8",
  null
  
)

export default component.exports